import { createApp } from 'vue';
import App from './App.vue';
import { sync } from 'vuex-router-sync';
import router from './router';
import axios from 'axios';
import Bus from '@/bus';
import { i18n } from '@/Helpers/language';

import { registerComponents } from './components';
import { registerDirectives } from './directives';
import { registerFilters } from './filters';
import { registerMixins } from './mixins';

import store from './store';

import { getMobileOperatingSystem } from '@/Helpers/mobile';

import { ErrorHandler } from '@/Handlers/ErrorHandler';
import { WarningHandler } from '@/Handlers/WarningHandler';
import { registerKeyCloakAuthService } from '@/Services/Keycloak/KeycloakAuthService';

require('../sass/app.scss');

require('@materializecss/materialize/dist/js/materialize.js');

window.$bus = Bus;
window.axios = axios;

const app = createApp(App);

app.config.globalProperties.$bus = Bus;

store.registerModule(
  'quincy',
  require('@/Modules/quincy/src/store/quincy').default
);

app.config.globalProperties.$debug = (...text) => {
  if (process.env.NODE_ENV === 'development') {
    console.log('debug:', ...text);
  }
};

app.config.performance = true;
app.config.errorHandler = ErrorHandler;
app.config.warnHandler = WarningHandler;

window.Device = getMobileOperatingSystem();

sync(store, router);

registerComponents(app);
registerDirectives(app);
registerFilters(app);
registerMixins(app);

const startApp = async () => {
  // Keycloak forces https so we skip it in development
  if (window.origin.startsWith('https')) {
    await registerKeyCloakAuthService(app);
  }
  app.use(i18n).use(router).use(store).mount('#app');
};

startApp();
